module.exports = __webpack_public_path__ + "img/article_a.a04b9660.png";